import axios from "axios"
import {API_URL} from "../constants"

export const getPropertyViews = async (path: string): Promise<number> => {
   const res = await axios.get(`${API_URL}/ga4/property-views`, {
      params: {path},
   })
   return res.data.views ?? 0
}
